$(() => {
  _handleZendeskChatSupportClick();
});

function _handleIntercomChatSupportClick() {
  $('.chat-support-trigger').on('click', () => {
    if (typeof Intercom !== "undefined") {
      Intercom('show');
    }
  });
}

function _handleZendeskChatSupportClick() {
  $('.chat-support-trigger').on('click', () => {
    if (typeof zE !== "undefined") {
      zE('messenger', 'open');
    }
  });
}
